import type { WithRequiredTheme, WithTheme } from '@opallabs/lapidary'
import { Me, Notification, Status } from '@opallabs/wormhole/types'

export type Runnable = () => void

export interface PreviewWorkflowItem {
  completedAt?: Date
  content: {
    id: string | number
    moment: {
      id: string | number
    }
  }
  dueDate: Date
  is_approved?: boolean
  is_new: boolean
  isDueAtDate: boolean
  phase: {
    phase_type: string
    name: string
  }
}

export interface MenuOption {
  title: string
  url: string
}

export type CheckpointTaskType = {
  child: 'todo' | 'upcoming' | 'completed' | 'overdue'
  parent: 'tasks'
}

export type CheckpointApprovalType = {
  child: 'pending' | 'completed'
  parent: 'approvals'
}

export type CheckpointType = CheckpointTaskType | CheckpointApprovalType

export type OwnProps = Readonly<
  WithTheme & {
    isViewOnlyRole: boolean
    notificationClickCallback: (arg: Notification) => void
    onTogglePersonalPanel: (markSeen: boolean, isOpen: boolean) => void
    onMenuClick: (arg: MenuOption) => void
    onNotificationClick: (arg: Notification) => void
    toggleLeftHandPreview: (content: PreviewWorkflowItem | null) => void
  }
>

export interface StateProps {
  status: Status | null
  user: Me | null
}

export interface DispatchProps {
  getStatus: Runnable
  onNotificationClick: (arg: Notification) => void
  togglePersonalPanel: (arg: boolean) => void
}

export type PersonalPanelProps = Omit<
  OwnProps & DispatchProps & StateProps,
  'notificationClickCallback'
>

export enum LocalStorageKeys {
  primaryTab = 'personal-panel-primary-tab',
  tasksSubTab = 'personal-panel-tasks-subtab',
  approvalsSubTab = 'personal-panel-approvals-subtab',
}

export type StyleProps = WithRequiredTheme
